export const INVALID_EMAIL_ADDRESS      = 'INVALID_EMAIL_ADDRESS';
export const UNKNOWN_EMAIL_ADDRESS      = 'UNKNOWN_EMAIL_ADDRESS';
export const DUPLICATED_CUSTOMER_EMAIL  = 'DUPLICATED_CUSTOMER_EMAIL';
export const INTERNAL_ERROR             = 'INTERNAL_ERROR';
export const RETRIEVE_TOKEN_NOT_FOUND   = 'RETRIEVE_TOKEN_NOT_FOUND';
export const INVALID_TOKEN              = 'INVALID_TOKEN';
export const DUPLICATE_USER             = 'DUPLICATE_USER';



// WEBPACK FOOTER //
// ./src/const/email_const.js